import React from "react";
import { useLocation } from "react-router-dom";
import * as Icons from "lucide-react";
import { PageHeader, ComingSoon, Footer } from "@/components/common/Page";

const META = {
    moderation: { title: "Moderation", icon: "ShieldAlert", sub: "Warnings, mutes, bans, reports and appeals with Discord sync." },
    tickets: { title: "Support Tickets", icon: "Ticket", sub: "Player reports, ban appeals and server issues." },
    economy: { title: "Economy", icon: "Coins", sub: "Per-community wallets, transactions and adjustments." },
    shop: { title: "Shop", icon: "Store", sub: "Manage shop items per community." },
    kits: { title: "Kits", icon: "Package", sub: "Define and deliver player kits." },
    maps: { title: "Maps", icon: "MapPin", sub: "Server maps, seeds and monument config." },
    automation: { title: "Automation", icon: "Cpu", sub: "Purge schedules, wipe automation and triggers." },
    integrations: { title: "Integrations", icon: "Zap", sub: "Discord, webhooks and external services." },
    analytics: { title: "Analytics", icon: "BarChart3", sub: "Player, economy and engagement insights." },
    settings: { title: "Settings", icon: "Sliders", sub: "Network-wide configuration." },
};

export default function AdminGeneric() {
    const loc = useLocation();
    const id = loc.pathname.split("/")[2];
    const m = META[id] || { title: id, icon: "Circle", sub: "" };
    const Icon = Icons[m.icon] || Icons.Circle;
    return (
        <div data-testid={`admin-${id}`}>
            <PageHeader title={m.title} subtitle={m.sub} />
            <ComingSoon title={m.title} icon={Icon} />
            <Footer />
        </div>
    );
}
